import { render, staticRenderFns } from "./ArtistEdit.vue?vue&type=template&id=36956252&scoped=true&"
import script from "./ArtistEdit.vue?vue&type=script&lang=js&"
export * from "./ArtistEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36956252",
  null
  
)

export default component.exports